import Cookies from 'js-cookie'

let millisecond = new Date().getTime()
let expiresTime = new Date(millisecond + 60 * 60 * 24 * 1000)

export function setUserName (val) {
  return Cookies.set('user_name', val, {expires: expiresTime})
}
export function getUserName () {
  return Cookies.get('user_name')
}

export function setOsType (val) {
  return Cookies.set('os_type', val, {expires: expiresTime})
}
export function getOsType () {
  return Cookies.get('os_type')
}

export function removeUserName () {
  return Cookies.remove('user_name')
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js